import script from "./QueSomos.vue?vue&type=script&setup=true&lang=js"
export * from "./QueSomos.vue?vue&type=script&setup=true&lang=js"

import "./QueSomos.vue?vue&type=style&index=0&id=043ef6dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043ef6dc"]])

export default __exports__